import React, { useState } from 'react'
import { useSponsorsContext } from '../context/sponsors/SponsorsProvider'
import { SPONSORS_ACTIONS } from '../context/sponsors/SPONSORS_ACTIONS'
import SponsorService from '../services/SponsorService'
import { useSponsorContext } from '../context/sponsor/SponsorProvider'
import { SPONSOR_ACTIONS } from '../context/sponsor/SPONSOR_ACTIONS'

export default function useSponsorsActions() {
  const { sponsorsDispatch } = useSponsorsContext()
  const { sponsorDispatch } = useSponsorContext()
  const [inProgress, setInProgress] = useState(false)

  async function getSponsors() {
    try {
      sponsorsDispatch({
        type: SPONSORS_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: true,
        },
      })
      const { data } = await SponsorService.getSponsors()

      sponsorsDispatch({
        type: SPONSORS_ACTIONS.SET_SPONSORS,
        payload: {
          sponsors: data.sponsors,
          pagination: {
            links: data.links,
            current_page: data.current_page,
            first_page: data.first_page,
            last_page: data.last_page,
          },
        },
      })
    } catch (error) {
    } finally {
      sponsorsDispatch({
        type: SPONSORS_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: false,
        },
      })
    }
  }

  async function createSponsor(payload) {
    try {
      setInProgress(true)
      const { data } = await SponsorService.createSponsor(payload)
      console.log(data)

      await getSponsors()
      return data.message
    } catch (error) {
      throw error
    } finally {
      setInProgress(false)
    }
  }

  async function getSponsor(sponsorId) {
    try {
      sponsorDispatch({
        type: SPONSOR_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: true,
        },
      })
      const { data } = await SponsorService.getSponsor(sponsorId)
      sponsorDispatch({
        type: SPONSOR_ACTIONS.SET_SPONSOR,
        payload: {
          sponsor: data.sponsor,
        },
      })
      return data.sponsor
    } catch (error) {
    } finally {
      sponsorDispatch({
        type: SPONSOR_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: false,
        },
      })
    }
  }

  async function updateSponsor(sponsorId, payload) {
    try {
      setInProgress(true)
      const { data } = await SponsorService.updateSponsor(sponsorId, payload)
      await getSponsor(sponsorId)
      return data.message
    } catch (error) {
      throw error
    } finally {
      setInProgress(false)
    }
  }

  const deleteSponsor = async (sponsorId) => {
    try {
      setInProgress(true)
      const { data } = await SponsorService.deleteSponsor(sponsorId)
      await getSponsors()
      return data.message
    } catch (error) {
      throw error
    } finally {
      setInProgress(false)
    }
  }

  async function changeSponsorStatus(sponsorId) {
    try {
      setInProgress(true)
      const { data } = await SponsorService.changeSponsorStatus(sponsorId)
      await getSponsors()
      return data.message
    } catch (error) {
      throw error
    } finally {
      setInProgress(false)
    }
  }
  return {
    getSponsors,
    getSponsor,
    createSponsor,
    updateSponsor,
    deleteSponsor,
    changeSponsorStatus,
    inProgress,
  }
}
